export const SET_PURCHASES = "SET_PURCHASES";
export const RESET_PURCHASES = "RESET_PURCHASES";
export const SET_SPECIFIC_PURCHASE = "SET_SPECIFIC_PURCHASE";
export const RESET_SPECIFIC_PURCHASE = "RESET_SPECIFIC_PURCHASE";
